import React from "react";
import InfiniteScrollComponent from "../../../../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import Loader from "../../../../../../components/Common/Loader/Loader";
import classes from "./ManageSeries.module.scss";
import SeriesList from "./SeriesList";

const ManageSeries = ({
  seriesDetails,
  radioBtnVal,
  repititiveValArr,
  totalRows,
  fetchMoreData,
  hasMoreData,
  seriesDetailsLoader,
  setValue,
  getUserGroupMandateShotClasses,
  selectVal,
}) => {
  return (
    <div className={classes.manageSeries}>
      {totalRows >= 6 ? (
        <InfiniteScrollComponent
          dataLength={seriesDetails?.length ? seriesDetails.length : 10}
          fetchMoreData={fetchMoreData}
          hasMoreData={hasMoreData}
          height={"100vh"}
          loader={true}
        >
          <SeriesList
            radioBtnVal={radioBtnVal}
            repititiveValArr={repititiveValArr}
            seriesDetails={seriesDetails}
            setValue={setValue}
            getUserGroupMandateShotClasses={getUserGroupMandateShotClasses}
            selectVal={selectVal}
          />
        </InfiniteScrollComponent>
      ) : (
        <SeriesList
          radioBtnVal={radioBtnVal}
          repititiveValArr={repititiveValArr}
          seriesDetails={seriesDetails}
          setValue={setValue}
          getUserGroupMandateShotClasses={getUserGroupMandateShotClasses}
          selectVal={selectVal}
        />
      )}
      {seriesDetails?.length === 0 && !seriesDetailsLoader && (
        <div className={classes.noRecordFound}>No Series Found</div>
      )}
      {seriesDetailsLoader && seriesDetails?.length === 0 && (
        <div className={classes.loader}>
          <Loader height="50" width="50" />
        </div>
      )}
    </div>
  );
};

export default ManageSeries;
